import { Result, ResultProps } from 'antd';
import styles from './index.module.scss';
import successCircle from '../../assets/svg/success-circle-fill.svg';
import { ReactNode } from 'react';

export const CommonResult = (props: ResultProps) => {
  const iconMap: Record<string, ReactNode> = {
    success: <img className={styles.icon} src={successCircle} />,
  };
  const icon = props.status ? iconMap[props.status] : undefined;

  return (
    <Result
      className={`${styles.result} ${props.className || ''}`}
      icon={icon}
      {...props}
    />
  );
};
